// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3RKD_","modalForm":"UpgradeEpcsModal_modalForm__2oQBJ","modalFooter":"UpgradeEpcsModal_modalFooter__2HlQs"};